import apiClient from 'core/services/apiClient/apiClient';
import {
  MatchExplanationsRequest,
  MatchExplanationsResponse,
  SourcingReplyRequest,
  SourcingReplyResponse,
  SourcingSearchRequest,
  SourcingSearchResponse
} from 'modules/candidate-profile/types/CandidateSearchFilter';

const SOURCING_SEARCH_PATH = '/sourcing/sourcing_search';
const SOURCING_EXPLANATIONS_PATH = '/sourcing/sourcing_search_explanations';
const SOURCING_REPLY_PATH = '/sourcing/sourcing_search_reply';

// Just above the endpoint's 90s so its own response wins.
const SOURCING_SEARCH_TIMEOUT_MS = 95_000;

export const postSourcingSearch = async (
  request: SourcingSearchRequest
): Promise<SourcingSearchResponse> => {
  const { data } = await apiClient.post<SourcingSearchResponse>(
    SOURCING_SEARCH_PATH,
    request,
    // apiClient sets no timeout, so without this a dropped connection hangs
    // the request for as long as the browser will hold it.
    { timeout: SOURCING_SEARCH_TIMEOUT_MS }
  );

  return data;
};

// Just above the endpoint's 30s.
const SOURCING_EXPLANATIONS_TIMEOUT_MS = 35_000;

export const fetchMatchExplanations = async (
  request: MatchExplanationsRequest
): Promise<MatchExplanationsResponse> => {
  const { data } = await apiClient.post<MatchExplanationsResponse>(
    SOURCING_EXPLANATIONS_PATH,
    request,
    { timeout: SOURCING_EXPLANATIONS_TIMEOUT_MS }
  );

  return data;
};

// Just above the endpoint's 30s.
const SOURCING_REPLY_TIMEOUT_MS = 35_000;

export const generateSourcingReply = async (
  request: SourcingReplyRequest
): Promise<SourcingReplyResponse> => {
  const { data } = await apiClient.post<SourcingReplyResponse>(
    SOURCING_REPLY_PATH,
    request,
    { timeout: SOURCING_REPLY_TIMEOUT_MS }
  );

  return data;
};
